<div class="table-container">
  <table class="table">
    <tbody>
      <tr class="tr" *ngIf="showCreateForm">
        <td colspan="1">
          <div class="create-comment-form">
            <comments-details
              [currentTicket]="currentTicket"
              [editModeComment]="true"
            ></comments-details>
          </div>
        </td>
      </tr>

 <ng-container *ngFor="let comment of comments | async">
  <tr *ngIf="selectedComment !== comment" [class.selected]="comment === selectedComment">
    <td class="container" colspan="2">
      <div class="comment-item">
        <button class="btn-edit" (click)="editComment(comment, $event)">
          <span class="material-icons-outlined">edit</span>
        </button>
        <div class="comment-content" [innerHTML]="sanitizeContent(comment.content)"></div>
      </div>
    </td>
  </tr>

  <tr *ngIf="selectedComment === comment" class="details-row">
    <td colspan="1">
      <div class="details-container">
        <div class="edit-header">
          <button class="btn-cancel" (click)="cancelEdit($event)">
            <span class="material-icons-outlined">close</span> 
          </button>
        </div>

        <comments-details
          [currentTicket]="currentTicket"
          [selectedComment]="selectedComment"
          [editModeComment]="true"
        ></comments-details>
      </div>
    </td>
  </tr>
</ng-container>

    </tbody>
  </table>
</div>
